import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import persistedReducer from '../reducers/persistedRootReducer';
import middleware from './middleware';

const preloadedState = {};

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(...middleware),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);
